import type {
  HousekeepingRoomStatus,
  Room,
  RoomAvailabilityStatus,
  RoomStatus,
} from "../types/room";

export function deriveRoomStatus(input: {
  housekeepingStatus: HousekeepingRoomStatus;
  availabilityStatus: RoomAvailabilityStatus;
}): RoomStatus {
  if (input.availabilityStatus === "out_of_order") return "out_of_order";
  if (input.availabilityStatus === "blocked") return "blocked";
  if (input.availabilityStatus === "out_of_service") return "out_of_service";
  return input.housekeepingStatus;
}

export function isRoomAssignable(room: Pick<Room, "availabilityStatus">) {
  return room.availabilityStatus === "available";
}

export function isRoomUnavailable(room: Pick<Room, "availabilityStatus">) {
  return room.availabilityStatus === "blocked"
    || room.availabilityStatus === "out_of_order"
    || room.availabilityStatus === "out_of_service";
}

export function isRoomReadyForCheckin(
  room: Pick<Room, "availabilityStatus" | "housekeepingStatus">
) {
  return isRoomAssignable(room) && (room.housekeepingStatus === "clean" || room.housekeepingStatus === "inspected");
}

export function applyRoomState(
  room: Room,
  patch: Partial<Pick<Room, "housekeepingStatus" | "availabilityStatus" | "activeBlockId" | "activeMaintenanceId" | "lastUpdatedAt" | "lastUpdatedBy">>
): Room {
  const next: Room = {
    ...room,
    ...patch,
  };

  return {
    ...next,
    status: deriveRoomStatus({
      housekeepingStatus: next.housekeepingStatus,
      availabilityStatus: next.availabilityStatus,
    }),
  };
}
